import React, { useEffect, useState } from "react";
import { Box, Button, Typography, TextField } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function CheckinConsoleEvents() {
  const navigate = useNavigate();
  const [orgId, setOrgId] = useState(sessionStorage.getItem("organizationId") || "");
  const [eventId, setEventId] = useState("");

  useEffect(() => {
    // No-op: keep simple for now
  }, []);

  const go = () => {
    if (!orgId || !eventId) return;
    navigate(`/checkin-console/${orgId}/${eventId}/scan`);
  };

  return (
    <Box sx={{ maxWidth: 520, mx: "auto", mt: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
        Select event
      </Typography>

      <TextField
        label="Organization ID"
        fullWidth
        size="small"
        value={orgId}
        onChange={(e) => setOrgId(e.target.value)}
        sx={{ mb: 1.5 }}
      />

      <TextField
        label="Event ID"
        fullWidth
        size="small"
        value={eventId}
        onChange={(e) => setEventId(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Button variant="contained" onClick={go} disabled={!orgId || !eventId}>
        Continue to Scanner
      </Button>
    </Box>
  );
}